import { CONTRACTS_TABS } from '@/modules/contract/entities/contants/contract';
import { CONTRACTS_TABS_ID } from '@/modules/contract/entities/enums/contract';
import useList from '@/modules/contract/hooks/useList/useList';
import React, { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import { Tabs } from 'vkit/lib/components';

interface TabContractStatusesProps {
  setCurrentTab: Dispatch<SetStateAction<CONTRACTS_TABS_ID>>;
  currentTab: CONTRACTS_TABS_ID;
}

const TabContractStatuses: React.FC<TabContractStatusesProps> = ({ setCurrentTab, currentTab }) => {
  const initialActiveTabIndex = useMemo(() => {
    return CONTRACTS_TABS.findIndex((tab) => tab.id === currentTab);
  }, [currentTab]);

  const { activeTab, handleChangeTabs, renderTabs } = useList({
    initialActiveTab: initialActiveTabIndex,
    contractsTabs: CONTRACTS_TABS,
  });

  useEffect(() => {
    setCurrentTab(CONTRACTS_TABS[activeTab].id);
  }, [activeTab, setCurrentTab]);

  return (
    <div data-testid='wrapper-tabs'>
      <Tabs iconDir='left' elements={[]} actions={renderTabs} onChange={handleChangeTabs} />
    </div>
  );
};

export default TabContractStatuses;
